import React, { Component } from 'react';

class ReadMore extends Component {
    constructor(props) {
        super(props);
        let data = props.data;
        this.state = {
            data: data,
            logo: data.logo,
            blurb: data.blurb,
            text: data.text,
            website: data.website,
            type: data.type,
        };
    };

    render() {
        const overlay = {
            backgroundColor: 'RGBA(5, 5, 5, 0.70)',
            position: 'absolute',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
        };

        const logo = {
            height: this.state.logo.height,
        };

        return (
            <div className="container-fluid p-4" style={overlay}>
                <div className="container container-width p-4">
                    <div className="row p-4" >
                        <div className="col-xs-12 col-sm-6 col-md-5 col-ls-4">
                            <img src={this.state.logo.image} style={logo} alt="logo"/>
                        </div>
                    </div>
                    <div className="row pt-2 pl-4 pr-4" >
                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-4">
                            <h4>{this.state.blurb}</h4>
                        </div>
                        <div className="col col-lg-6">
                            <h5>{this.state.text[1]}</h5>
                            <br />
                            <h5>{this.state.text[2]}</h5>
                            <br />
                            <div className="row flex-row justify-content-between">
                                <button className="link-button" onClick={this.props.clickHandler} ><h5><span className="right-arrow">←</span> read less</h5></button>
                                {
                                    (this.state.type === 'project') ? (
                                        <a className="link-button" target="_blank" rel="noopener noreferrer" href={this.state.data.video}><h5>see it for yourself <span className="right-arrow">→</span></h5></a>
                                    ) : (
                                        <a className="link-button" target="_blank" rel="noopener noreferrer" href={this.state.website}><h5>read further <span className="right-arrow">→</span></h5></a>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/modal/read-more.js